// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cv-row__margins[data-v-7087dd10]{margin-left:1.6px;margin-right:1.6px;margin-top:1.6px}", ""]);
// Exports
module.exports = exports;
